import { initI18n, dispatchCustomEventGlobally } from 'www/utils'

const TRUNCATION_TOLERANCE_PX = 1

function getTextCutElement(aboutBlock: HTMLElement) {
  return aboutBlock.querySelector<HTMLElement>(
    '.doctor-info-about__text-cut--desktop, .doctor-info-about__text-cut--redesign',
  )
}

function isTextOverflowing(textEl: HTMLElement) {
  return textEl.scrollHeight > textEl.clientHeight + TRUNCATION_TOLERANCE_PX
}

function updateTruncationState(aboutBlock: HTMLElement) {
  if (aboutBlock.classList.contains('doctor-info-about--expanded')) {
    return
  }

  const textEl = getTextCutElement(aboutBlock)

  if (!textEl) {
    return
  }

  aboutBlock.classList.toggle('doctor-info-about--no-truncation', !isTextOverflowing(textEl))
}

function observeTruncation(aboutBlock: HTMLElement) {
  const textEl = getTextCutElement(aboutBlock)

  if (!textEl) {
    return
  }

  updateTruncationState(aboutBlock)

  const resizeObserver = new ResizeObserver(() => {
    updateTruncationState(aboutBlock)
  })

  resizeObserver.observe(textEl)

  const contentEl = aboutBlock.querySelector('.doctor-info-about__content')

  if (contentEl) {
    resizeObserver.observe(contentEl)
  }
}

function initTruncationStates() {
  document.querySelectorAll('.doctor-info-about--desktop, .doctor-info-about--redesign').forEach(aboutBlock => {
    observeTruncation(aboutBlock as HTMLElement)
  })

  document.fonts?.ready.then(() => {
    document.querySelectorAll('.doctor-info-about--desktop, .doctor-info-about--redesign').forEach(aboutBlock => {
      updateTruncationState(aboutBlock as HTMLElement)
    })
  })
}

async function init() {
  const { i18next } = await initI18n({ bundle: 'doctors.mobile.blocks/common/doctor-info-about' })

  initTruncationStates()

  document.querySelectorAll('.doctor-info-about--desktop .doctor-info-about__more-btn').forEach(moreBtn => {
    moreBtn.addEventListener('click', () => {
      const aboutBlock = moreBtn.closest<HTMLElement>('.doctor-info-about--desktop')

      if (!aboutBlock) {
        return
      }

      const isExpanded = aboutBlock.classList.toggle('doctor-info-about--expanded')

      moreBtn.setAttribute('aria-expanded', String(isExpanded))

      if (!isExpanded) {
        aboutBlock.querySelector<HTMLElement>('.doctor-info-about__text-cut--desktop')?.scrollTo(0, 0)
        updateTruncationState(aboutBlock)
      }
    })
  })

  document.querySelectorAll('.doctor-info-about--redesign .doctor-info-about__more-btn').forEach(moreBtn => {
    moreBtn.addEventListener('click', () => {
      dispatchCustomEventGlobally('open-content-bottom-sheet', {
        title: i18next.t('Врач о себе', { ns: i18next.language }),
        contentSelector: '.doctor-info-about__text-cut',
        prepareContent: (content: string) => content.replace('doctor-info-about__text-cut', ''),
      })
    })
  })

  const doctorVideoBtn = document.querySelector('.doctor-info-about__video-btn')

  if (doctorVideoBtn) {
    doctorVideoBtn.addEventListener('click', () => {
      dispatchCustomEventGlobally('click-video-preview-image')
    })
  }

  document.querySelectorAll('.doctor-info-about__video-intro').forEach(doctorVideoIntro => {
    doctorVideoIntro.addEventListener('click', () => {
      dispatchCustomEventGlobally('click-video-preview-image')
    })
  })
}

init()
